<template>
    <div id='todayActive' :toiframe='toiframe' :awardIdPointer='awardIdPointer'>
		<div id="mask" class="mask"></div>
	  	<div class="mission">
			<div class='todayCon'>
				<p class="missionsign">{{uiTitle}}</p>
				<ul id='ulCon'>
					<img class="missionhand" src="~assets/images/hand.png" alt="">
					<li v-for='(item,index) in missionList' :key="item.missionId" :id="item.missionId" :class="index==0?'showmission':''">
						<div class='pad'>
							<span class="mission-title">{{item.missionDesc}}&nbsp;&nbsp;</span>
							<span class='over' v-if='item.awardStatus == 2 || item.awardStatus == 1'>已完成</span>
							<span class='rate' v-if='item.awardStatus == 0'>进度:{{item.userProgress}}/{{item.totalProgress}}</span>
						</div>
						<div class='prize'>
							<div class="bs">
								<b v-for='(i,ind) in item.awardList' :key='ind'>
									<span class='icon'><img :src="i.icon" alt=""></span>
									<span class='awardName'>{{i.awardName == '金币' ? i.awardQuantity : i.awardName == '现金' ? i.awardQuantity/100 : i.awardName}}</span>
									<span>{{i.awardName == '金币' ? '金币' : i.awardName == '现金' ? '元' : '*' + i.awardQuantity}}</span>
								</b>
							</div>
							<div class='button receiveOver' v-if='item.awardStatus == 2' disabled='disabled'>领取成功</div>
							<div class='button receiveCan' v-if='item.awardStatus == 1'
							@click='goAward(item.missionId,index,item.awardStatus)'>可领取</div>
							<div class='button goReceive' v-if='item.awardStatus == 0'
							@click='jump(item.jumpType,item.jumpParam1,item.jumpParam2,item.jumpType2,item.jumpParam4,0,item.missionId)'>前往完成</div>
							
						</div>
						<p class='rightop' v-if='item.awardStatus == 2'>今日无次数</p>
						<p class='rightop' v-else>今日剩余<span style="color:rgba(253,79,45,1);margin-left:0.05rem;">{{item.dailyLimit-item.userLimit}}次</span></p>
					</li>
				</ul>
			</div>
	  	</div>
   </div>
</template>
<script>
	import $ from 'jquery'
	import {mapState,mapMutations} from 'vuex'
	import config from "@/../config"
	import vm from '../../main'
	import qs from 'qs'
	import active from'@/utils/axios/index'

	export default {
		data() {
			return {
				uiTitle: '',
				missionList: []//任务列表
			}
		},
		computed:{
			...mapState([
				'uuid',
				'activityStatus',
				'activityId',
				'time',
				'guide'
			])
		},
		created() {
			this.missionIdPointer()
		},
		methods: {
			//初始化获取数据
			missionIdPointer(){
				active.getMission(config.API_HOST +'/apiserv/api/mission/getMission',qs.stringify({
					missionIdPointer: this.awardIdPointer,
					uuid:this.uuid,
					activityId: this.activityId
				})).then((res) => {
					if (res.return_code == 200) { 
						this.uiTitle = res.data.uiTitle
						this.missionList = res.data.missionList
						this.$nextTick(() =>{
							document.querySelector('.mask').style.height = document.querySelector('#todayActive').clientHeight + 'px'
							document.querySelector('.mask').style.width = 3.5 + 'rem'
						})
					}
				})
			},
			// 判断活动状态
			lock(){
				if (this.activityStatus == 0) { //活动展示期
					this.tipConshow('【' + this.time + '】开启活动，请耐心等待');
					return false;
				} else if (this.activityStatus == 1) {
					$('.button').attr('disabled', false)
					return true;
				} else if (this.activityStatus == 2) {
					this.tipConshow("活动已结束，请等待下次活动");
					return false;
				} else {
					this.tipConshow("活动已关闭，请等待下次活动");
					return false;
				}
			},
			//点击去完成任务
			jump(jumpType, jumpParam1, jumpParam2, jumpType2, jumpParam4, awardStatus, missionId){
				// 首次进入页面的时候转盘的引导之后会做任务的引导（点击之后页面的一些样式修改）
				vm.$children[0].$children[0].missionshow = vm.$children[0].$children[0].missionshow ? false : false
				document.querySelector('.missionhand').style.display = 'none'
				var activehand = document.querySelector('.hand')//这个是转盘的手指（需要进行判断，有时候页面中没有转盘这个组件）
				if(activehand){
					document.querySelector('.hand').style.display = 'none'
				}
				vm.$children[0].$children[0].$el.style.overflowY = 'scroll'
				document.querySelector('.showmission').style.zIndex = 0;
				//判断是否是在活动时间内
				var continu = this.lock();
				if (continu) {
					this.$tea('event_activemodal_missionbtn_10101', { 'awardStatus': awardStatus, 'activityId': this.activityId, 'missionId': missionId, guide:this.guide?this.guide:false });//数据埋点
					if (typeof Android != 'undefined') { //运行环境为233小游戏
						if (jumpType == 1) {//调用安卓方法
							var bool = Android.activeJump(jumpParam1, jumpParam2)
							if (bool == false) {
								this.tipConshow("版本过低，无法自动跳转，但任务可完成");
							}
						} else if (jumpType == 2) {//跳转web——url
							window.location.href = jumpParam2
						} else {//弹出提示信息
							this.tipConshow("赶紧去做任务吧");
						}
					} else if (typeof MetaX != 'undefined') { //运行环境为233乐园
						if (jumpType2 == 6) {
							let strIndex = jumpParam4.lastIndexOf('game_id');
							let gameId = jumpParam4.substring(strIndex + 8, jumpParam4.length);
							let resId = {'categoryID': 4701, 'gameId': gameId, 'isSpec': 1, 'param1': this.activityId, 'param2': missionId, 'source': 1, 'status': 0}
							window.location.href = jumpParam4 + '&resId=' + JSON.stringify(resId);
						} else {//弹出提示信息
							this.tipConshow("赶紧去做任务吧");
						}
					}
				} 
			},
			//完成任务，并领取奖励（status: 1:领取成功  2:失败）
			goAward(missionId, index, awardStatus){
				var continu = this.lock()//判断是否在活动期间
				if (continu) {
					this.$tea('event_activemodal_missionbtn_10101', { 'awardStatus': awardStatus, 'activityId': this.activityId, 'missionId': missionId, guide:this.guide?this.guide:false });//数据埋点
					active.missionAward(config.API_HOST +'/apiserv/api/mission/missionAward', qs.stringify({
						missionId: missionId,
						uuid: this.uuid,
						activityId: this.activityId
					})).then((res) =>{
						if (res.return_code == 200) {
							if (res.data.status == 1) {
								//领取成功
								this.$tea('event_activemodal_missionsuccess_10101', { 'activityId': this.activityId, 'missionId': missionId, guide:this.guide?this.guide:false });//数据埋点
								this.awardResult = res.data.awardList
								this.missionList[index].awardStatus = res.data.awardStatus
								this.missionList[index].totalProgress = res.data.totalProgress
								this.missionList[index].userProgress = res.data.userProgress
								this.missionList[index].userLimit = res.data.userLimit
								this.tipConshow2(this.awardResult)
								//需要对金币现金做处理
								if (typeof Android != 'undefined') { //运行环境为小游戏才需要执行
									for (var i = 0; i < this.awardResult.length; i++) {
										if (this.awardResult[i].awardName == '现金') {
											Android.addUserBalance(this.awardResult[i].awardQuantity / 100, 'CASH')
										} else if (this.awardResult[i].awardName == '金币') {
											Android.addUserBalance(this.awardResult[i].awardQuantity, 'GOLD')
										}
									}
								}
							} else {//领取失败
								this.tipConshow("领取失败");
							}
						} else {
							this.tipConshow(res.return_msg);
						}
					})
				}
			},
		},
	}
</script>
<style lang="less" scoped>
button, p{
	margin: 0;
	padding: 0;
}
#todayActive {
	width: 100%;
	height: auto;
	margin-top: 0.4rem;
	z-index: 10;
}
#mask{
	position: absolute;
	width: 100%;
	height: 100%;
	z-index: 10;
	border-radius: 0.12rem;
	display: none;
	// background: #FDCB18;
	// margin-top: 0.2rem;
}
.mission{
	background: #FFF;
	width: 100%;
	border-radius: 0.12rem;
}
.todayCon {
	width: 100%;
	height: auto;
	margin-top: 0.2rem;
	border: 0.02rem solid #FDCB18;
	box-sizing: border-box;
	padding: 0 0.12rem;
	border-radius: 0.12rem;
}
.missionsign {
	width: 90%;
	height: 0.37rem;
	background: url('~assets/images/sign.svg') no-repeat top;
	background-size: contain;
	margin-top: -0.2rem;
	margin-left: 5%;
	text-align: center;
	font-size: 0.18rem;
	font-weight: 600;
	color: rgba(249, 249, 249, 1);
	line-height: 0.3rem;
}
#ulCon {
	width: 100%;
	height: auto;
	padding: 0.2rem 0;
	position: relative;
}
.missionhand{
	position: absolute;
    top: 0.8rem;
    left: 86%;
    z-index: 110;
	display: none;
	width: 0.6rem;
}
#ulCon li {
	width: 100%;
	min-height: 0.89rem;
	background: rgba(247, 247, 247, 1);
	border-radius: 0.04rem;
	margin-top: 0.1rem;
	padding: 0.12rem 0.08rem;
	display: flex;
	flex-direction: column;
	position: relative;
}	
.pad {
	width: 100%;
	font-size: 0.12rem;
	font-family: PingFangSC-Semibold, sans-serif;
	font-weight: 600;
	color: rgba(51, 51, 51, 1);
	line-height: 0.17rem;
	display: flex;;
	flex-wrap: wrap;
}
.over {
	height: 0.16rem;
	background: url('~assets/images/over.svg') no-repeat center;
	font-size: 0.12rem;
	font-weight: 400;
	color: rgba(44, 187, 127, 1);
	line-height: 0.16rem;
	text-align: center;
	background-size: cover;
	margin-left: 0.08rem;
}
.rate {
	height: 0.17rem;
	background: url('~assets/images/rate.svg') no-repeat center;
	font-size: 0.12rem;
	font-family: PingFangSC-Semibold, sans-serif;
	font-weight: 400;
	color: rgba(255, 86, 89, 1);
	line-height: 0.17rem;
	text-align: center;
	margin-left: 0.08rem;
	background-size: cover;
}
.prize {
	width: 100%;
	min-height: 0.13rem;
	font-size: 0.13rem;
	font-family: PingFangSC-Semibold, sans-serif;
	font-weight: 400;
	color: rgba(102, 102, 102, 1);
	display: inline-flex;
}
.prize b {
	display: inline-block;
	width: 50%;
	font-weight: 400;
	line-height: 0.28rem;
}
.prize b:nth-child(1) {
	margin-left: 0;
}
.prize .bs{
	width: 75%;
}
.prize span {
	display: block;
	float: left;
}
.icon {
	width: 0.12rem;
	height: 0.12rem;
	margin-right: 0.05rem;
	margin-top: 0.08rem;
}
.icon img {
	display: block;
	width: 100%;
	height: 100%;
}
.awardName {
	display: block;
	overflow: hidden;
	white-space: nowrap;
	text-overflow: ellipsis;
}
.button {
	width: 0.72rem;
	height: 0.28rem;
	font-size: 0.12rem;
	font-weight: 500;
	color: rgba(255, 255, 255, 1);
	line-height: 0.28rem;
	border: 0;
	outline: none;
	border-radius: 0.18rem;
	margin-top: 0.03rem;
	text-align: center;
}
.button:active.focus{
	outline: none;
	border-color: transparent;
	box-shadow: none;
}
.button:active {
	transform: scale(0.9)
}
.receiveOver {
	background: rgba(221, 221, 221, 1);
	box-shadow: 0 0.02rem 0 0 rgba(179, 179, 179, 1);
}
.receiveCan {
	background: rgba(253, 79, 45, 1);
	box-shadow: 0 0.02rem 0 0 rgba(188, 15, 6, 1);
}
.goReceive {
	background: rgba(255, 142, 31, 1);
	box-shadow: 0 0.02rem 0 0 rgba(232, 89, 0, 1);
}
.rightop {
	text-align: left;
	font-size: 0.12rem;
	color: rgba(153, 153, 153, 1);
	line-height: 0.12rem;
}
@keyframes white {
  20%{
    background: rgba(238, 238, 238, 1);
  }
  50%{
    background: rgba(238, 238, 238, 0);
  }
  75%{
    background: rgba(238, 238, 238, 1);
  }
  100%{
    background: rgba(238, 238, 238, 0)
  }
}

</style>